function fnHorizontalSlider(i, oSection) {
  if (window.innerWidth <= 860) return;

  gsap.context(() => {
    const texts = gsap.utils.toArray(".content-col .item");
    const images = gsap.utils.toArray(".images-col .item");

    ScrollTrigger.create({
      trigger: ".container",
      pin: true,
      start: () =>
        `top top+=${
          (window.innerHeight -
            oSection.querySelector(".container").offsetHeight) *
          0.5
        }`,
      end: () => "+=" + texts.length * window.innerHeight,
      invalidateOnRefresh: true,
    });

    const textTl = gsap.timeline({
      scrollTrigger: {
        trigger: oSection,
        scrub: true,
        start: () =>
          `top top+=${
            (window.innerHeight -
              oSection.querySelector(".container").offsetHeight) *
            0.5
          }`,
        end: () => "+=" + texts.length * window.innerHeight,
        toggleActions: "play none reverse none",
        invalidateOnRefresh: true,
      },
    });

    const imagesTL = gsap.timeline({
      scrollTrigger: {
        trigger: oSection,
        scrub: true,
        start: () =>
          `top top+=${
            (window.innerHeight -
              oSection.querySelector(".container").offsetHeight) *
            0.5
          }`,
        end: () => "+=" + images.length * window.innerHeight,
        toggleActions: "play none reverse none",
        invalidateOnRefresh: true,
      },
    });

    texts.map((el, idx) => {
      if (idx != 0) {
        textTl.set(
          el,
          {
            x: `${idx * -100}%`,
          },
          "<"
        );

        textTl.to(
          el,
          {
            opacity: 1,
          },
          "<"
        );
      }

      if (idx < texts.length - 1) {
        textTl.to(
          el,
          {
            opacity: 0,
          },
          "+=.8"
        );
      }
    });

    images.map((el, idx) => {
      if (idx != 0) {
        imagesTL.fromTo(
          el,
          {
            opacity: 0,
            scale: 0.8,
            x: "160%",
          },
          {
            opacity: 1,
            scale: 0.8,
            x: "80%",
          },
          "<"
        );

        imagesTL.to(
          el,
          {
            scale: 1,
            x: 0,
          },
          `item-${idx}`
        );
      }
    });
  }, oSection);
}
